import { Breadcrumb } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PATH from '@/config/paths/PATH';
import { getPathUrl } from '@/utils';
import { useUnsaved } from '@/contexts/UnsavedContext';
import { UnsavedChangesModal } from '../AppModal/modals';
import useMediaQuery, { mediaQueryPoints } from '@/hooks/useMediaQuery';

const nonClickableSegmentNames = ['create', 'update', 'edit', 'detail'];
const toBeUppercaseWhiteList = ['sms'];

const formatSegment = (segment) =>
  segment
    .split('-')
    .map((word) => {
      if (toBeUppercaseWhiteList.includes(word.toLowerCase())) {
        return word.toUpperCase();
      }
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');

const AppBreadcrumb = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { hasUnsaved } = useUnsaved();
  const pathUrl = getPathUrl(pathname);
  const isMobileXsm = useMediaQuery(`(max-width: ${mediaQueryPoints.xsm}px)`);

  const onNavigate = (e, href, isClickable) => {
    e.preventDefault();
    if (!isClickable) return;

    if (hasUnsaved) {
      UnsavedChangesModal(() => navigate(href));
    } else {
      navigate(href);
    }
  };

  const buildItem = (key, name, href, isLast, isDynamic) => {
    const label = isDynamic ? 'Detail' : formatSegment(name);
    const isClickable =
      !isLast && !isDynamic && !nonClickableSegmentNames.includes(name.toLowerCase());

    return {
      key,
      title: (
        <span className={`flex items-center gap-1 ${isMobileXsm ? 'text-xs' : 'text-sm'}`}>
          {label}
        </span>
      ),
      href,
      className: classNames(
        isClickable ? 'cursor-pointer hover:text-primary' : 'pointer-events-none',
        isLast && '!text-black'
      ),
      onClick: (e) => onNavigate(e, href, isClickable),
    };
  };

  const breadcrumbItems = [
    buildItem('dashboard', 'Dashboard', PATH.HOME, false, false),
    ...pathUrl.map((item, index) =>
      buildItem(index, item.name, item.url, index === pathUrl.length - 1, item.isDynamicSegment)
    ),
  ];

  return <Breadcrumb className="app-breadcrumb flex items-center" items={breadcrumbItems} />;
};

export default AppBreadcrumb;
